"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedCurrencyAmount = void 0;
var getBackwardsCompatibleNumberFormat_1 = require("./getBackwardsCompatibleNumberFormat");
/**
 * Util function to get formatted currency amount
 *
 * @param locale
 * @param currency ISO Currency Code
 * @param amount Given in cents when applicable
 * @param showDecimals
 */
var getFormattedCurrencyAmount = function (locale, currency, amount, showDecimals) {
    if (showDecimals === void 0) { showDecimals = false; }
    var options = null;
    // if the amount includes cents (amount % 100 !== 0) and we want to show decimals,
    // then show exactly 2 fraction digits
    if (amount % 100 !== 0 && showDecimals) {
        options = {
            style: "currency",
            currencyDisplay: "narrowSymbol",
            currency: currency || "eur",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
    }
    else {
        options = {
            style: "currency",
            currencyDisplay: "narrowSymbol",
            currency: currency || "eur",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        };
    }
    var numberFormat = (0, getBackwardsCompatibleNumberFormat_1.getBackwardsCompatibleNumberFormat)(locale || "en", options);
    var parts = numberFormat.formatToParts(amount / 100);
    var currencyCode = currency.toUpperCase().slice(0, -1);
    var formatedCurrencyAmount = "";
    if (currencyCode === "EU" || currencyCode === "GB")
        return numberFormat.format(amount / 100);
    else {
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (part.type === "currency") {
                formatedCurrencyAmount += "".concat(currencyCode, " ").concat(part.value); // If the part is the currency symbol, add currencyCode in front
            }
            else {
                formatedCurrencyAmount += part.value;
            }
        }
        return formatedCurrencyAmount;
    }
};
exports.getFormattedCurrencyAmount = getFormattedCurrencyAmount;
